﻿import { store$ } from '@redux/store';
import { map, distinctUntilChanged, filter } from 'rxjs';

const userLocationSelector = (state) => state?.userProfile?.userLocation;
const validValuesFilter = (value) => !!value;
const isDataLayerValid = () => !!window.dataLayer;

/**
 * A function that push information to dataLayer.
 */
const updateDataLayer = (data) => {
  setTimeout(() => window.dataLayer.push(data), 0);
};

/**
 * Update the dataLayer when user information is ready.
 * The user location information must be pushed to the dataLayer always.
 */
store$
  .pipe(filter(isDataLayerValid), map(userLocationSelector), distinctUntilChanged(), filter(validValuesFilter))
  .subscribe(updateDataLayer);

export default updateDataLayer;
